import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u771446010/domains/dev.jbcodeapp.in/hbuilds/source/repository/components/Partials/DynamicPortfolio.tsx");
;
import(/* webpackMode: "eager" */ "/home/u771446010/domains/dev.jbcodeapp.in/hbuilds/source/repository/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/u771446010/domains/dev.jbcodeapp.in/hbuilds/source/repository/node_modules/next/dist/client/link.js");
